import React           from 'react';
import { makeStyles }  from '@material-ui/core/styles';

const [heb, arab] = [`עברית`, `عربي`]

const useStyles = makeStyles(() => ({
    root: {
        top:        0,
        left:       0,
        position:   'fixed',
        height:     100,
        width:      '100vw',
        display:    'flex',
        zIndex:     9999,
    },
    selector: {
       width:           110,
       height:          40,
       marginTop:       10,
       marginRight:     10,
       marginLeft:      10,
       borderRadius:    '0.5em',
       backgroundColor: '#404B76',
       color:           '#FFF',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       textAlign:       'center',
       '&:hover': {
          backgroundColor: '#606B96',
       }
    }
}))

type LangSelectorProps = {
    lang:    string;
    setLang: (val: string) => void;
}

const LangSelector: React.FC<LangSelectorProps> = ({ lang, setLang }) => {

  const classes = useStyles();


  return (
    <div className = { classes.root }>
        <div 
            className = { classes.selector }
            onClick   = { () => { if (lang !== 'heb') { setLang('heb') }}}
            style     = {{
                cursor:          lang === 'heb' ? 'default' : 'pointer',
                backgroundColor: lang !== 'heb' ? '#404B76' : '#606B96',
            }}
        >
            { heb }
        </div>
        <div 
            className = { classes.selector }
            onClick   = { () => { if (lang !== 'arab') { setLang('arab') }}}
            style     = {{
                cursor:          lang === 'arab' ? 'default' : 'pointer',
                backgroundColor: lang !== 'arab' ? '#404B76' : '#606B96',
            }}
        >
            { arab }
        </div>
    </div>
  );
}



export default LangSelector;
